export class CustomEmojiApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async list() {
        return this.client.get('/api/custom-emojis');
    }
    async create(params) {
        return this.client.post('/api/custom-emojis', params);
    }
    async get(id) {
        return this.client.get(`/api/custom-emojis/${encodeURIComponent(id)}`);
    }
    async update(id, params) {
        return this.client.patch(`/api/custom-emojis/${encodeURIComponent(id)}`, params);
    }
    async delete(id) {
        return this.client.delete(`/api/custom-emojis/${encodeURIComponent(id)}`);
    }
}
//# sourceMappingURL=custom-emoji-api.js.map